/**
 * Tentaläge's timed drill buttons (slice D, P2-3): one press starts the session and moves to the
 * run, as a set link does. With too few open problems it says so and stays.
 */
import { useState } from "react";
import { useNavigate } from "react-router";
import { Button, useToast } from "@client/components/ui";
import { useT } from "@client/i18n";
import { messageForError } from "@client/lib/errors";
import { saveSession } from "../session";
import { TIMED_DRILLS, startTimedDrill, type TimedDrill } from "./timedDrill";

export function TimedDrillButtons() {
  const t = useT();
  const toast = useToast();
  const navigate = useNavigate();
  const [busy, setBusy] = useState<number | null>(null);

  async function start(drill: TimedDrill) {
    setBusy(drill.minutes);
    try {
      const session = await startTimedDrill(drill);
      if (!session) {
        toast.show(t("practice.drill.empty"));
        setBusy(null);
        return;
      }
      saveSession(session);
      navigate("/practice/session");
    } catch (error) {
      toast.error(messageForError(error, t));
      setBusy(null);
    }
  }

  return (
    <div className="flex flex-wrap gap-2">
      {TIMED_DRILLS.map((drill) => (
        <Button
          key={drill.minutes}
          variant="secondary"
          size="sm"
          disabled={busy !== null}
          onClick={() => void start(drill)}
        >
          {t("practice.drill.label", { minutes: drill.minutes, count: drill.problems })}
        </Button>
      ))}
    </div>
  );
}
